import { makeAutoObservable } from "mobx";

/*** Option Object ***/

export interface IOptionObject {
    value: string;
}

export interface INumericalIdOptionObject {
    id: number;
}

/*** Option ***/

export interface IOption<T> {
    selected: boolean;
    disabled: boolean;
    object: T;
}

export class Option<T = {}> implements IOption<T> {
    selected: boolean;
    disabled: boolean;
    object: T;

    constructor(object: T, selected: boolean, disabled?: boolean) {
        makeAutoObservable(this);

        this.object = object;
        this.selected = selected;
        this.disabled = disabled || false;
    }

    toggleSelection() {
        this.selected = !this.selected;
    }

    setDisabled(disabled: boolean) {
        this.disabled = disabled;
    }
}